import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bcom-computer-application',
  templateUrl: './bcom-computer-application.component.html',
  styleUrls: ['./bcom-computer-application.component.scss']
})
export class BcomComputerApplicationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
